export default __webpack_public_path__ + "static/media/estate_donate.3e6acd59.svg";